import {
  APP_SETTING_UPDATE_DEV_KEY_BEGIN,
  APP_SETTING_UPDATE_DEV_KEY_SUCCESS,
  APP_SETTING_UPDATE_DEV_KEY_FAILURE,
  APP_SETTING_UPDATE_DEV_KEY_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function updateDevKey(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_UPDATE_DEV_KEY_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/devKey`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: APP_SETTING_UPDATE_DEV_KEY_SUCCESS,
              data: res.data,
              envId: args.uuid,
              action: args.action,
            });
            toast.success(args.msg, {});
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },

        (err) => {
          dispatch({
            type: APP_SETTING_UPDATE_DEV_KEY_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateDevKeyError() {
  return {
    type: APP_SETTING_UPDATE_DEV_KEY_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_UPDATE_DEV_KEY_BEGIN:
      return {
        ...state,
        updateDevKeyPending: true,
        updateDevKeyError: null,
      };

    case APP_SETTING_UPDATE_DEV_KEY_SUCCESS:
      const environments = state.projectDetail.environments;
      const index = state.projectDetail.environments.findIndex((env) => env.uuid === action.envId);
      environments[index].key = action.data.key;
      return {
        ...state,
        updateDevKeyPending: false,
        updateDevKeyError: null,
        projectDetail: {
          ...state.projectDetail,
          environments,
        },
      };

    case APP_SETTING_UPDATE_DEV_KEY_FAILURE:
      return {
        ...state,
        updateDevKeyPending: false,
        updateDevKeyError: action.data.error,
      };

    case APP_SETTING_UPDATE_DEV_KEY_DISMISS_ERROR:
      return {
        ...state,
        updateDevKeyError: null,
      };

    default:
      return state;
  }
}
